var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 221 85.9",
    style: {
      enableBackground: "new 0 0 221 85.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1061B;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#010100;}\n\t.st3{fill:#FDEA18;}\n\t.st4{fill:#00B3E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_214",
    transform: "translate(2000.603 -1104.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_212",
    transform: "translate(-2000.603 1104.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_460",
    className: "st0",
    d: "M-0.3,19.6v38.1l221,0.2V19.6L-0.3,19.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_206",
    transform: "translate(9.79 28.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_461",
    className: "st1",
    d: "M20.6,25.1l-2.4-6.4H7l-2.4,6.4h-6.5L9.8-3.5h5.9l11.6,28.6H20.6 M14.1,8.1 c-0.6-1.7-1.2-3.4-1.5-4.5c-0.3,1.1-0.9,2.8-1.5,4.5l-2,5.2h7L14.1,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_462",
    className: "st1",
    d: "M56.2,25.1V14.6c0-1.6,0.1-5.2,0.1-6.3c-0.4,1.1-1.3,3.1-2.1,4.7L48,25.8l-6.2-12.7 c-0.8-1.6-1.7-3.7-2.1-4.7c0,1.1,0.1,4.7,0.1,6.3v10.5h-6V-3.5h5.9L46,9.5c0.8,1.6,1.7,3.8,2.1,4.8c0.4-1.1,1.3-3.1,2-4.8 l6.1-12.9h6v28.6H56.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_463",
    className: "st1",
    d: "M71.5,25.1V-3.5h21.1v5.6h-15v5.7h10.3v5.6H77.6v6.2h15.7v5.6L71.5,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_464",
    className: "st1",
    d: "M118.5,25.1l-5.4-10.3H107v10.3h-6.1V-3.5H115c5.7,0,10.5,3,10.5,9.1c0,4.3-2,7-5.8,8.4 l5.8,11.1H118.5 M114.9,2.1h-8v7.4h8c2.8,0,4.4-1.2,4.4-3.7C119.3,3.1,117.6,2.1,114.9,2.1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    x: 133.7,
    y: -3.5,
    className: "st1",
    width: 6.1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_465",
    className: "st1",
    d: "M167.4,4.8c-1.2-2-3-3.1-6-3.1c-4.9,0-7.7,3.8-7.7,9.1c0,5.1,2.9,9.1,7.8,9.1 c2.9,0,4.7-1.1,6.4-3.6l5.5,2.9c-2.2,4-6.2,6.5-12.1,6.5c-8.6,0-14.3-5.7-14.3-14.7c0-8.7,6-14.8,14.6-14.8 c6.2,0,9.9,2.6,12,6.3L167.4,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_466",
    className: "st1",
    d: "M197.2,25.1l-2.4-6.4h-11.1l-2.4,6.4h-6.5l11.7-28.6h5.9l11.6,28.6H197.2 M190.8,8 c-0.6-1.7-1.2-3.4-1.5-4.5c-0.3,1.1-0.9,2.8-1.5,4.5l-2,5.2h7L190.8,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_467",
    className: "st1",
    d: "M197.9-0.5c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0c2.2,0,3.9,1.8,3.9,3.9c0,0,0,0,0,0 c0,2.2-1.8,3.9-3.9,3.9c0,0,0,0,0,0C199.7,3.4,197.9,1.6,197.9-0.5C197.9-0.5,197.9-0.5,197.9-0.5 M198.5-0.5 c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4C200-3.9,198.5-2.4,198.5-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_468",
    className: "st1",
    d: "M202.8-1.3c-0.2-0.3-0.5-0.5-0.9-0.4c-0.6,0-1.1,0.5-1.1,1.1c0,0.1,0,0.1,0,0.2 c-0.1,0.6,0.4,1.2,1,1.2c0,0,0.1,0,0.1,0c0.4,0,0.7-0.2,0.9-0.5l0.8,0.4c-0.4,0.6-1,1-1.7,0.9c-1.1,0.1-2-0.7-2.1-1.8 c0-0.1,0-0.2,0-0.3c-0.1-1.1,0.8-2,1.9-2.1c0.1,0,0.1,0,0.2,0c0.7-0.1,1.4,0.3,1.7,0.9L202.8-1.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_207"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    x: -0.3,
    y: 0.1,
    className: "st2",
    width: 111.2,
    height: 19.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_208",
    transform: "translate(0.125 68.442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    x: -0.3,
    y: -11,
    className: "st3",
    width: 221.1,
    height: 10.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_209",
    transform: "translate(11.76 70.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_469",
    className: "st2",
    d: "M1.5-5.1h-3.7v-4.8h1.1v3.9h2.7L1.5-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_470",
    className: "st2",
    d: "M3.8-5.1H2.8v-4.8h1.1V-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_471",
    className: "st2",
    d: "M9.3-9H7.7v3.9H6.7V-9H5.2v-0.9h4.1L9.3-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_472",
    className: "st2",
    d: "M14.3-9h-1.5v3.9h-1.1V-9h-1.5v-0.9h4.1L14.3-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_473",
    className: "st2",
    d: "M19.3-5.1h-3.8v-4.8h3.7V-9h-2.6v0.8h1.5v0.9h-1.5v1.2h2.7V-5.1z M18.7-11.3l-1.1,1.1h-0.9 l0.7-1.1L18.7-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_474",
    className: "st2",
    d: "M24.9-5.1h-1.2l-0.9-1.7h-1.1v1.7h-1.1v-4.8h2.5c1,0,1.8,0.5,1.8,1.5c0,0.7-0.4,1.2-1,1.4 L24.9-5.1z M23.8-8.4c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C23.6-7.8,23.8-8,23.8-8.4L23.8-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_475",
    className: "st2",
    d: "M31-5.1h-1.2l-0.4-1.1h-1.9L27-5.1h-1.1l2-4.8h1L31-5.1z M29-7.1L28.7-8 c-0.1-0.3-0.2-0.6-0.3-0.7c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3,0.9H29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_476",
    className: "st2",
    d: "M35.9-9h-1.5v3.9h-1.1V-9h-1.5v-0.9h4.1L35.9-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_477",
    className: "st2",
    d: "M41.4-7.2c0.1,1.1-0.7,2.1-1.8,2.2c-0.1,0-0.3,0-0.4,0c-1.1,0.1-2.1-0.7-2.1-1.8 c0-0.1,0-0.2,0-0.3v-2.7h1.1v2.7c0,0.8,0.4,1.3,1.1,1.3c0.7,0,1.1-0.5,1.1-1.2v-2.7h1.1L41.4-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_478",
    className: "st2",
    d: "M47.2-5.1H46l-0.9-1.7H44v1.7H43v-4.8h2.5c1,0,1.8,0.5,1.8,1.5c0,0.7-0.4,1.2-1,1.4 L47.2-5.1z M46.2-8.4c0-0.4-0.3-0.6-0.8-0.6H44v1.2h1.4C45.9-7.8,46.2-8,46.2-8.4L46.2-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_479",
    className: "st2",
    d: "M52.4-5.1h-3.8v-4.8h3.7V-9h-2.6v0.8h1.5v0.9h-1.5v1.2h2.7V-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_480",
    className: "st2",
    d: "M57.6-6.6C57.6-5.7,57-5,55.5-5c-0.8,0-1.5-0.3-2.1-0.9l0.8-0.6C54.6-6.2,55.1-6,55.6-6 c0.6,0,0.9-0.2,0.9-0.5c0-0.3-0.2-0.4-1.2-0.7c-1-0.2-1.7-0.5-1.7-1.4c0-0.9,0.8-1.4,1.9-1.4c0.7,0,1.4,0.3,1.9,0.8l-0.8,0.7 c-0.3-0.3-0.8-0.5-1.2-0.5c-0.6,0-0.8,0.2-0.8,0.4c0,0.3,0.2,0.4,1.1,0.6C56.7-7.9,57.6-7.6,57.6-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_481",
    className: "st2",
    d: "M65.9-5.1h-1.2l-0.4-0.4c-0.4,0.3-1,0.5-1.5,0.5C61.6-5,61-5.5,61-6.3 c0-0.6,0.5-1.2,1.1-1.4l-0.1-0.1c-0.3-0.2-0.4-0.6-0.5-1c0-0.8,0.7-1.2,1.6-1.2c0.6,0,1.1,0.2,1.6,0.5l-0.5,0.7 C63.8-9,63.4-9.2,63-9.2c-0.3,0-0.5,0.1-0.5,0.3c0,0.2,0.1,0.4,0.3,0.5l1.5,1.5c0.1-0.3,0.3-0.5,0.4-0.8l0.9,0.3 c-0.1,0.4-0.3,0.8-0.6,1.2L65.9-5.1z M63.7-6.1l-1-1C62.2-6.9,62-6.7,62-6.4c0,0.3,0.3,0.5,0.8,0.5C63.1-5.9,63.4-6,63.7-6.1 L63.7-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_482",
    className: "st2",
    d: "M73.3-8.9l-1,0.4c-0.2-0.3-0.6-0.6-1-0.5c-0.8,0-1.2,0.6-1.2,1.5c0,0.9,0.5,1.5,1.3,1.5 c0.4,0,0.8-0.2,1-0.6l0.9,0.5c-0.4,0.7-1.1,1.1-2,1.1C70.1-5,69-6,69-7.2c0-0.1,0-0.2,0-0.3c-0.1-1.3,0.9-2.4,2.1-2.5 c0.1,0,0.1,0,0.2,0C72.1-10.1,72.9-9.7,73.3-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_483",
    className: "st2",
    d: "M78.8-7.2c0.1,1.1-0.7,2.1-1.8,2.2c-0.1,0-0.3,0-0.4,0c-1.1,0.1-2.1-0.7-2.1-1.8 c0-0.1,0-0.2,0-0.3v-2.7h1.1v2.7C75.6-6.5,76-6,76.7-6c0.7,0,1.1-0.5,1.1-1.2v-2.7h1.1L78.8-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_484",
    className: "st2",
    d: "M84.1-5.1h-3.7v-4.8h1.1v3.9h2.7L84.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_485",
    className: "st2",
    d: "M89-9h-1.5v3.9h-1.1V-9h-1.5v-0.9H89L89-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_486",
    className: "st2",
    d: "M94.5-7.2c0.1,1.1-0.7,2.1-1.8,2.2c-0.1,0-0.3,0-0.4,0c-1.1,0.1-2.1-0.7-2.1-1.8 c0-0.1,0-0.2,0-0.3v-2.7h1.1v2.7c0,0.8,0.4,1.3,1.1,1.3c0.7,0,1.1-0.5,1.1-1.2v-2.7h1.1L94.5-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_487",
    className: "st2",
    d: "M100.4-5.1h-1.2l-0.9-1.7h-1.1v1.7h-1.1v-4.8h2.5c1,0,1.8,0.5,1.8,1.5c0,0.7-0.4,1.2-1,1.4 L100.4-5.1z M99.3-8.4C99.3-8.8,99-9,98.5-9h-1.4v1.2h1.4C99-7.8,99.3-8,99.3-8.4L99.3-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_488",
    className: "st2",
    d: "M105.5-5.1h-3.8v-4.8h3.7V-9h-2.6v0.8h1.5v0.9h-1.5v1.2h2.7V-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_489",
    className: "st2",
    d: "M110.7-6.6c0,0.9-0.6,1.5-2.1,1.5c-0.8,0-1.5-0.3-2.1-0.9l0.8-0.6c0.4,0.4,0.8,0.6,1.4,0.5 c0.6,0,0.9-0.2,0.9-0.5c0-0.3-0.2-0.4-1.2-0.7c-1-0.2-1.7-0.5-1.7-1.4c0-0.9,0.8-1.4,1.9-1.4c0.7,0,1.4,0.3,1.9,0.8l-0.8,0.7 c-0.3-0.3-0.8-0.5-1.2-0.5c-0.6,0-0.8,0.2-0.8,0.4c0,0.3,0.2,0.4,1.1,0.6C109.8-7.9,110.7-7.6,110.7-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_490",
    className: "st2",
    d: "M118.7-7.5c0,1.7-1.3,2.4-2.7,2.4h-1.6v-4.8h1.7C117.6-9.9,118.7-9.3,118.7-7.5z  M117.7-7.5c0-1-0.5-1.5-1.6-1.5h-0.6v2.9h0.5C117.1-6.1,117.7-6.7,117.7-7.5L117.7-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    className: "st2",
    d: "M121.1-9.9L120.5-8h-0.7l0.1-1.9H121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_492",
    className: "st2",
    d: "M127.1-5.1h-1.2l-0.4-1.1h-1.9l-0.4,1.1H122l2-4.8h1L127.1-5.1z M125.1-7.1L124.8-8 c-0.1-0.3-0.2-0.6-0.3-0.7c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3,0.9H125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_493",
    className: "st2",
    d: "M133.2-5.1h-1.1v-1.8c0-0.3,0-0.9,0-1.1c-0.1,0.2-0.2,0.5-0.4,0.8L130.7-5l-1.1-2.1 c-0.1-0.3-0.3-0.6-0.4-0.8c0,0.2,0,0.8,0,1.1v1.8h-1v-4.8h1l1.1,2.2c0.1,0.3,0.3,0.6,0.4,0.8c0.1-0.2,0.2-0.5,0.4-0.8l1.1-2.2h1 L133.2-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_494",
    className: "st2",
    d: "M138.6-5.1h-3.8v-4.8h3.7V-9h-2.6v0.8h1.5v0.9h-1.5v1.2h2.7L138.6-5.1z M138-11.3l-1.1,1.1 h-0.9l0.7-1.1L138-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_495",
    className: "st2",
    d: "M144.2-5.1H143l-0.9-1.7H141v1.7h-1.1v-4.8h2.5c1,0,1.8,0.5,1.8,1.5c0,0.7-0.4,1.2-1,1.4 L144.2-5.1z M143.1-8.4c0-0.4-0.3-0.6-0.8-0.6H141v1.2h1.4C142.9-7.8,143.1-8,143.1-8.4L143.1-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_496",
    className: "st2",
    d: "M146.7-5.1h-1.1v-4.8h1.1V-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_497",
    className: "st2",
    d: "M152.7-7.5c0,0.7-0.2,1.4-0.7,1.8l0.4,0.5l-0.8,0.5l-0.4-0.5c-0.3,0.1-0.5,0.1-0.8,0.1 c-1.2,0-2.3-0.9-2.3-2.2c0-0.1,0-0.2,0-0.3c-0.1-1.2,0.8-2.3,2-2.5c0.1,0,0.2,0,0.3,0c1.2,0,2.3,0.9,2.3,2.2 C152.7-7.7,152.7-7.6,152.7-7.5z M151.6-7.5c0-0.9-0.4-1.5-1.2-1.5c-0.9,0-1.2,0.7-1.2,1.5c0,0.9,0.4,1.6,1.2,1.6 c0.1,0,0.1,0,0.2,0l-0.4-0.5l0.8-0.5l0.3,0.5C151.5-6.8,151.6-7.2,151.6-7.5L151.6-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_498",
    className: "st2",
    d: "M158.2-7.2c0.1,1.1-0.7,2.1-1.8,2.2c-0.1,0-0.3,0-0.4,0C155-5,154-5.8,153.9-6.9 c0-0.1,0-0.2,0-0.3v-2.7h1.1v2.7c0,0.8,0.4,1.3,1.1,1.3c0.7,0,1.1-0.5,1.1-1.2v-2.7h1.1L158.2-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_499",
    className: "st2",
    d: "M163.6-5.1h-3.8v-4.8h3.7V-9h-2.6v0.8h1.5v0.9h-1.5v1.2h2.7L163.6-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_500",
    className: "st2",
    d: "M171.6-7.5c0,1.7-1.3,2.4-2.7,2.4h-1.6v-4.8h1.7C170.5-9.9,171.6-9.3,171.6-7.5z  M170.5-7.5c0-1-0.5-1.5-1.6-1.5h-0.6v2.9h0.5C170-6.1,170.5-6.7,170.5-7.5L170.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_501",
    className: "st2",
    d: "M177.1-7.2c0.1,1.1-0.7,2.1-1.8,2.2c-0.1,0-0.3,0-0.4,0c-1.1,0.1-2.1-0.7-2.1-1.8 c0-0.1,0-0.2,0-0.3v-2.7h1.1v2.7c0,0.8,0.4,1.3,1.1,1.3s1.1-0.5,1.1-1.2v-2.7h1.1L177.1-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_502",
    className: "st2",
    d: "M185.4-5.1h-0.9l-1.9-2.6c-0.1-0.2-0.3-0.4-0.4-0.5c0,0.2,0,0.8,0,1.1v2.1h-1v-4.8h1 l1.9,2.5c0.1,0.2,0.3,0.4,0.4,0.5c0-0.2,0-0.8,0-1.1v-2h1V-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503",
    className: "st2",
    d: "M191.4-7.5c0.1,1.2-0.8,2.4-2,2.5c-0.1,0-0.2,0-0.3,0c-1.2,0.1-2.3-0.9-2.3-2.1 c0-0.1,0-0.2,0-0.3c-0.1-1.2,0.8-2.4,2-2.5c0.1,0,0.2,0,0.3,0c1.2,0,2.3,0.9,2.3,2.2C191.4-7.8,191.4-7.6,191.4-7.5z M190.3-7.5 c0-1-0.5-1.5-1.3-1.5c-0.7,0-1.2,0.5-1.2,1.5S188.3-6,189-6C189.8-6,190.3-6.5,190.3-7.5L190.3-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_504",
    className: "st2",
    d: "M196.9-5.1h-1.2l-0.9-1.7h-1.1v1.7h-1.1v-4.8h2.5c1,0,1.8,0.5,1.8,1.5c0,0.7-0.4,1.2-1,1.4 L196.9-5.1z M195.8-8.4c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C195.6-7.8,195.8-8,195.8-8.4L195.8-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_505",
    className: "st2",
    d: "M202.6-7.5c0,1.7-1.3,2.4-2.7,2.4h-1.6v-4.8h1.7C201.4-9.9,202.6-9.3,202.6-7.5z  M201.5-7.5c0-1-0.5-1.5-1.6-1.5h-0.6v2.9h0.5C201-6.1,201.5-6.7,201.5-7.5z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    x: -0.1,
    y: 68.2,
    className: "st4",
    width: 149.6,
    height: 17.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_211",
    transform: "translate(10.425 85.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_506",
    className: "st1",
    d: "M5.7-12.8l-3,8H1l-3-8h1.9l1.6,4.6c0.2,0.4,0.3,1,0.4,1.3C2-7.2,2.1-7.7,2.3-8.2l1.6-4.6 H5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_507",
    className: "st1",
    d: "M9.1-4.8H7.4v-8h1.7V-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_508",
    className: "st1",
    d: "M18.2-4.8h-1.5l-3.1-4.4c-0.2-0.3-0.5-0.7-0.6-0.9c0,0.3,0,1.3,0,1.7v3.5h-1.7v-8H13l3,4.2 c0.2,0.3,0.5,0.7,0.6,0.9c0-0.3,0-1.3,0-1.7v-3.4h1.7L18.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_509",
    className: "st1",
    d: "M26.8-11.1l-1.6,0.7c-0.3-0.6-0.9-0.9-1.5-0.9c-1.3,0-2,1-2,2.5c0,1.4,0.7,2.5,2,2.5 c0.7,0,1.4-0.4,1.7-1l1.4,0.8c-0.6,1.2-1.8,1.9-3.1,1.8c-2.2,0-3.7-1.6-3.7-4.1c0-2.4,1.5-4.1,3.8-4.1C25-13,26.2-12.3,26.8-11.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_510",
    className: "st1",
    d: "M34.6-4.8h-6.1v-8h5.9v1.6h-4.2v1.4h2.4v1.6h-2.4v1.9h4.4L34.6-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_511",
    className: "st1",
    d: "M43.2-4.8h-1.5l-3.1-4.4c-0.2-0.3-0.5-0.7-0.6-0.9c0,0.3,0,1.3,0,1.7v3.5h-1.7v-8H38l3,4.2 c0.2,0.3,0.5,0.7,0.6,0.9c0-0.3,0-1.3,0-1.7v-3.4h1.7L43.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_512",
    className: "st1",
    d: "M52.3-4.8h-1.5l-3.1-4.4c-0.2-0.3-0.5-0.7-0.6-0.9c0,0.3,0,1.3,0,1.7v3.5h-1.7v-8H47l3,4.2 c0.2,0.3,0.5,0.7,0.6,0.9c0-0.3,0-1.3,0-1.7v-3.4h1.7L52.3-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_513",
    className: "st1",
    d: "M60.5-4.8h-6.1v-8h5.9v1.6h-4.2v1.4h2.4v1.6h-2.4v1.9h4.4L60.5-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_514",
    className: "st1",
    d: "M68.5-7.2c0,1.5-1,2.5-3.3,2.5c-1.3,0.1-2.5-0.5-3.3-1.4l1.2-1c0.6,0.6,1.3,0.9,2.2,0.9 c1,0,1.5-0.3,1.5-0.9c0-0.5-0.3-0.7-1.9-1.1c-1.6-0.3-2.7-0.8-2.7-2.4c0-1.4,1.4-2.3,3-2.3c1.2,0,2.3,0.4,3.1,1.3l-1.2,1.1 c-0.5-0.5-1.2-0.8-1.9-0.8c-0.9,0-1.2,0.4-1.2,0.7c0,0.5,0.4,0.7,1.7,1C67-9.4,68.5-9,68.5-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_515",
    className: "st1",
    d: "M78.4-13.8l-3.9,10h-1.6l3.9-10H78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_516",
    className: "st1",
    d: "M89.1-11.2h-4.4v1.5h2.6v1.6h-2.6v3.4H83v-8h6.1V-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_517",
    className: "st1",
    d: "M97.4-4.8h-1.9L94-7.7h-1.7v2.9h-1.7v-8h3.9c1.6,0,2.9,0.8,2.9,2.5c0.1,1.1-0.6,2-1.6,2.3 L97.4-4.8z M95.7-10.2c0-0.7-0.5-1-1.2-1h-2.2v2.1h2.2C95.3-9.2,95.7-9.5,95.7-10.2L95.7-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    className: "st1",
    d: "M106.7-4.8h-1.9l-0.7-1.8h-3.1l-0.7,1.8h-1.8l3.2-8h1.6L106.7-4.8z M103.6-8.1l-0.5-1.4 c-0.2-0.5-0.3-0.9-0.4-1.2c-0.1,0.3-0.3,0.8-0.4,1.2l-0.5,1.4H103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    className: "st1",
    d: "M115.2-4.8h-1.5l-3.1-4.4c-0.2-0.3-0.5-0.7-0.6-0.9c0,0.3,0,1.3,0,1.7v3.5h-1.7v-8h1.6 l3,4.2c0.2,0.3,0.5,0.7,0.6,0.9c0-0.3,0-1.3,0-1.7v-3.4h1.7L115.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_520",
    className: "st1",
    d: "M123.7-11.1l-1.6,0.7c-0.3-0.6-0.9-0.9-1.5-0.9c-1.3,0-2,1-2,2.5c0,1.4,0.7,2.5,2,2.5 c0.7,0,1.4-0.4,1.7-1l1.4,0.8c-0.6,1.2-1.8,1.9-3.1,1.8c-2.2,0-3.7-1.6-3.7-4.1c0-2.4,1.5-4.1,3.8-4.1 C121.9-13,123.2-12.3,123.7-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_521",
    className: "st1",
    d: "M131.5-4.8h-6.1v-8h5.9v1.6h-4.2v1.4h2.4v1.6h-2.4v1.9h4.4L131.5-4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_213",
    transform: "translate(-1987.036 1110.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_522",
    className: "st1",
    d: "M-2.5-0.8h7.9v2.1h-5.6v2.2h5v2.1h-5v4h-2.3V-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_523",
    className: "st1",
    d: "M10.3-0.8h7.9v2h-5.6v2.1h4.9v2h-4.9v2.2h5.7v2h-7.9L10.3-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_524",
    className: "st1",
    d: "M22.5,8.2l1.4-1.6c0.9,0.8,2,1.2,3.1,1.3c0.9,0,1.5-0.4,1.5-1v0c0-0.6-0.4-0.9-2.1-1.3 c-2.1-0.5-3.5-1.1-3.5-3.2v0c0-1.9,1.5-3.1,3.7-3.1c1.4,0,2.8,0.4,3.9,1.3l-1.2,1.7c-0.8-0.6-1.7-1-2.7-1c-0.9,0-1.3,0.4-1.3,0.9 v0c0,0.7,0.4,0.9,2.2,1.4c2.1,0.6,3.3,1.3,3.3,3.1v0c0,2.1-1.6,3.2-3.8,3.2C25.3,9.8,23.7,9.2,22.5,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_525",
    className: "st1",
    d: "M38,1.4h-3.2v-2.1h8.6v2.1h-3.2v8.3H38V1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_526",
    className: "st1",
    d: "M48.3-0.8h2.3V9.7h-2.3V-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_527",
    className: "st1",
    d: "M55.3-0.8h2.5l2.7,7.3l2.7-7.3h2.5L61.5,9.7h-2L55.3-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_528",
    className: "st1",
    d: "M72.4-0.8h2.1L79,9.7h-2.4l-1-2.3h-4.4l-1,2.3h-2.3L72.4-0.8z M74.8,5.3l-1.4-3.4L72,5.3 H74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_529",
    className: "st1",
    d: "M83.6-0.8h2.3v8.3h5.2v2.1h-7.5L83.6-0.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.26bfee3da44b97700316afd7b3c3133d.svg";
export { ForwardRef as ReactComponent };